<template>
	<div id="app">
		<router-view />
		<HoverList @pause="pauseVideo" class="floatingOfficeButton" :leftList="coursewareList" :rightList="videoList"
			@toggleOffice="toggleOffice" @toggleVideo="toggleVideo"  @clickOffice="clickOffice"
			v-if="$store.state.coursewareList || videoList.length > 0" />
		<div class="VabOnlyOffice" v-show="isOfficeVisible">
			<div v-loading="coursewareLoading" >

				<div  style="height: 100vh; height: 100dvh;" >
					<keep-alive>
					
						<CourseOffice :option="option"  />
					</keep-alive>
				</div>
			</div>
		</div>
		<div class="VabOnlyOffice" v-show="isHtmlVisible">
			<div v-loading="htmlLoading">
				<div style="height: 100vh; height: 100dvh;">
					<iframe v-if="htmlContent" :srcdoc="htmlContent" class="html-courseware-iframe" allow="microphone; autoplay"></iframe>
				</div>
			</div>
		</div>
			<video ref="courseVideo"
				v-if="this.videoList.length !== 0" v-show="isVideoVisible" class="coursewareVideo" controls
				:src="currentVideoUrl"><track kind="captions"></video>
	</div>
</template>
<script>
import VabOnlyOffice from './components/other/vanOnkyOffice.vue'
import CourseOffice from '@shared/components/readeCourseOffice.vue'
import HoverList from './components/other/hoverList.vue'
import { load_html_from_oss } from '@/api/studentData'
import questionRuntime, { stripAllScripts, katexInject } from '@shared/utils/question-runtime.js'
import { cspPrepareSrcdoc } from '@/utils/csp-nonce'
export default {
	name: 'App',
	components: {
		VabOnlyOffice, HoverList, CourseOffice
	},
	data() {
		return {

			selectedVideoId: null,//选中的视频id
			optionChangeTag: true, //   改变就强制刷新VabOnlyOffice组件
			isOfficeVisible: false, // 控制VabOnlyOffice组件的显示和隐藏  
			isVideoVisible: false, // 控制video组件的显示和隐藏  
			option: {
				key: "",
				url: "",
				isEdit: "",
				fileType: "",
				title: "",
				lang: "",
				isPrint: "",
				download: "",
			},
			videoList: [],
			coursewareList: [],
			currentVideoUrl: '',
			coursewareLoading:false,
			isHtmlVisible: false, // 控制HTML课件iframe的显示和隐藏
			htmlContent: '', // HTML课件内容
			htmlLoading: false, // HTML课件加载状态
			currentHtmlCoursewareId: null, // 当前正在播放的HTML课件id(用于区分关闭与切换)
		};
	},
	mounted() {	
	
		if (this.$store.state.coursewareList) {
		
			this.coursewareList = this.$store.state.coursewareList
		}
		if (this.$store.state.coursewarevideoList) {
			this.videoList = this.$store.state.coursewarevideoList
		}
	},
	watch: {
		'$store.state.coursewareList'(newVal) {
			if (newVal) {
				if (newVal.length == 0) {
					return
				}

				this.coursewareList =this.$store.state.coursewareList
			} else {
				this.coursewareList = []
			}
		},
		'$store.state.coursewarevideoList'(newVal) {
			if (newVal) {

				this.videoList = newVal
			} else {
				this.videoList = []
			}
		}
	},
	methods: {
		
		toggleVideo(item) {
			if (this.isVideoVisible) {
				if (item.url == this.currentVideoUrl) {
					this.selectedVideoId = null
					this.isVideoVisible = false
				} else {
					this.currentVideoUrl = item.url
					this.selectedVideoId = item.id
					this.$nextTick(() => {
						if (this.$refs.courseVideo) {
							this.$refs.courseVideo.play()
						}
					})
				}
			} else {
				this.currentVideoUrl = item.url
				this.isVideoVisible = true
				this.isHtmlVisible = false
				this.selectedVideoId = item.id
				this.$nextTick(() => {
					if (this.$refs.courseVideo) {
						this.$refs.courseVideo.play()
					}
				})
			}
		},
		toggleOffice() {
			this.isOfficeVisible = !this.isOfficeVisible;
		},
		pauseVideo() {
		
				this.$refs.courseVideo.pause();
		
		},
		clickOffice(val){
			if (this.isVideoVisible && this.$refs.courseVideo) {
				this.$refs.courseVideo.pause();
				this.$refs.courseVideo.currentTime = 0;
			}
			this.isVideoVisible = false;
			this.selectedVideoId = null;

			// HTML格式课件（教学课件html）走iframe渲染
			// 同一课件再点=关闭; 不同课件=直接切换播放(与PPT的onlyoffice行为一致)
			const isHtml = (val.file_type || '').toLowerCase() === 'html';
			if (isHtml) {
				this.isOfficeVisible = false;
				if (this.isHtmlVisible && this.currentHtmlCoursewareId === val.id) {
					// 再次点击同一课件: 关闭(内容保留, 下次打开从上次进度继续)
					this.isHtmlVisible = false;
				} else if (this.currentHtmlCoursewareId === val.id && this.htmlContent) {
					// 切换音频/视频/课件后切回: 只恢复显示, 不重新加载(避免课件从头播放)
					this.isHtmlVisible = true;
				} else {
					this.isHtmlVisible = true;
					this.currentHtmlCoursewareId = val.id;
					this.loadHtmlCourseware(val);
				}
				return;
			}

			// 切走时只隐藏不清内容, 保留 HTML 课件的播放进度
			this.isHtmlVisible = false;

			this.option = {
					isEdit: false,
					lang: "zh-CN",
					key: "",
					url:val.url,
					title:val.courseware_name,
					fileType: val.file_type,
					isPrint: false,
					download: false,
					
				}
			
				this.coursewareLoading = true;
				this.optionChangeTag = false
				setTimeout(() => {
					this.optionChangeTag = true
					this.coursewareLoading = false;
				}, 0)
		},
		async loadHtmlCourseware(val){
			const url = val.orign_url || val.url;
			if (!url) {
				this.$message.warning('课件地址无效');
				return;
			}
			this.htmlLoading = true;
			this.htmlContent = '';
			const res = await load_html_from_oss({ html_url: url });
			if (res && res.data && res.data.html) {
				// 与互动题链路一致: 剥原文脚本并注入标准运行时(学生课件含互动题/听讲解时才能正常交互)
				const clean = stripAllScripts(res.data.html);
				// replacement 必须函数式: katexInject delimiters 的 "$$" 在字符串 replacement 里会被
				// replace 特殊模式折叠成 "$", $$ 块级公式随之渲染错乱(2026-10-27 根因)
				this.htmlContent = cspPrepareSrcdoc(clean.replace('</body>', () => katexInject + '<script>' + questionRuntime + '<' + '/script></body>'));
			} else {
				this.$message.warning('课件加载失败');
			}
			this.htmlLoading = false;
		}
	}
}
</script>

<style lang="scss" scoped>

#app {
    overflow: hidden;
    position: relative;
}

.floatingOfficeButton {
	position: fixed; // 使用fixed定位使按钮悬浮  
	bottom: 5px; // 距离右侧20px  
	left: 50%; // 距离顶部50%  
	transform: translateX(-50%); // 使用transform使按钮垂直居中  
	z-index: 10000; // 确保按钮在最上层  
	display: flex;
}

.VabOnlyOffice {
	z-index: 9998; // 确保按钮在最上层 
	position: fixed; // 使用fixed定位使按钮悬浮   
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
}

.html-courseware-iframe {
	width: 100%;
	height: 100%;
	border: none;
	background: #fff;
}

.coursewareVideo {
	position: fixed;
	z-index: 9999;
	top: 0;
	left: 0;
	width: 100vw;
	height: calc(100vh - 60px);
	height: calc(100dvh - 60px);
	object-fit: contain;
}

.coursewareListBtn {
	background: var(--th-primary);
	border: none;
	border-radius: 980px;
	padding: 6px 18px;
	min-width: 88px;
	color: var(--th-on-primary);
	font-size: 13px;
	font-weight: 500;
	text-shadow: none;
	cursor: pointer;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
	transition: background-color 0.2s ease, transform 0.15s ease;
}

.coursewareListBtn:hover {
	background: var(--th-primary-bright);
}

.coursewareListBtn:active {
	transform: scale(0.96);
}

.videoListItem {
	cursor: pointer;
	display: inline-block;
	line-height: 1;
	white-space: nowrap;
	background: var(--th-panel);
	border: 1px solid var(--th-hairline);
	border-radius: 980px;
	padding: 6px 14px;
	color: var(--th-text);
	font-size: 13px;
	font-weight: 500;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
	transition: background-color 0.2s ease, transform 0.15s ease;
}

.videoListItem:active {
	transform: scale(0.96);
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s, transform 0.5s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
	transform: translateY(30px);
}

.optionbutton:active {
	transform: scale(0.9);
}

.selectedVideoIdCss {
	filter: brightness(0.8);
	/* 选中时降低图片亮度 */
}

</style>
